<div
  class="payment-methods-item"
  [ngClass]="{ 'is-selected': formGroup.get('paymentMethod').value === (paymentMethod.uiId || paymentMethod.id) }"
>
  <div class="payment-methods-item-header">
    <app-radio-button
      [control]="formGroup.get('paymentMethod')"
      [id]="id + '-' + (paymentMethod.uiId || paymentMethod.id)"
      [label]="paymentMethod.name"
      [value]="paymentMethod.uiId || paymentMethod.id"
      [name]="'paymentMethod'"
    >
      <ng-container
        content-after
        *ngIf="
          formGroup.get('paymentMethod').value === (paymentMethod.uiId || paymentMethod.id) &&
          isShowHint(paymentMethod.providerPaymentCode, paymentMethod.codeId) &&
          !isSkipHints
        "
      >
        <div class="payment-methods-item-hint-message">
          {{ hintText(paymentMethod.providerPaymentCode, paymentMethod.codeId) | translate }}
        </div>
      </ng-container>
    </app-radio-button>

    <div class="payment-methods-item-icon">
      <img [src]="paymentMethod.icon" />
    </div>
  </div>

  <div
    class="payment-methods-item-fee"
    *ngIf="isShowFee && formGroup.get('paymentMethod').value === (paymentMethod.uiId || paymentMethod.id) && allFees"
  >
    {{ "PRODUCT_CODE.COLLECTION_FEE" | translate }} {{ allFees }}
  </div>
</div>
